/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchLookupTokenTypeRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {BatchLookupTokenTypeResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const batchLookupTokenType = (request: BatchLookupTokenTypeRequest, options?: CashRequestOptions) => post<BatchLookupTokenTypeRequest, BatchLookupTokenTypeResponse>("/2.0/cash/batch-lookup-token-type", request, {...options, rejectOnError: true })